import LZString from 'lz-string';

const dataName = 'jobmap_data';
const timeName = 'jobmap_time';

export const getMarkers = (date: string) => {
  if (date.length && window.localStorage.getItem(timeName) === date) {
    return LZString.decompressFromUTF16(window.localStorage.getItem(dataName) as string);
  }
  window.localStorage.removeItem(timeName);
  window.localStorage.removeItem(dataName);
  return '';
};
export const setMarkers = (items: any, date: string) => {
  const compressed = LZString.compressToUTF16(JSON.stringify(items));
  window.localStorage.setItem(timeName, date);
  window.localStorage.setItem(dataName, compressed);
};
